import _ from 'lodash';
import ILoanEmailAttachment from './ILoanEmailAttachment';
import ILoanEmailRecipient from './ILoanEmailRecipient';
import ILoanEmail from './ILoanEmail';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseLoanEmail(raw: any): ILoanEmail {
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attachments: _.map(raw.attachments, (attachment: any): ILoanEmailAttachment => ({
            bytes: attachment.bytes,
            contentId: attachment.contentId,
            contentType: attachment.contentType,
            filename: attachment.filename,
            uuid: attachment.uuid,
        })),
        loanUuid: raw.loanUuid,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        recipients: _.map(raw.recipients, (recipient: any): ILoanEmailRecipient => ({
            email: recipient.email,
            name: recipient.name,
            type: recipient.type,
        })),
        senderEmail: raw.senderEmail,
        senderName: raw.senderName,
        sentTime: raw.sentTime,
        subject: raw.subject,
        summary: raw.summary,
        uuid: raw.uuid,
    };
}
